const TRUE_VALUES = new Set(["1", "true", "yes", "on"]);

export function parseAnimationFlag(value) {
  if (value === true) {
    return true;
  }

  if (typeof value !== "string") {
    return false;
  }

  return TRUE_VALUES.has(value.trim().toLowerCase());
}

export const displayAnimationFlags = {
  enableDisplayAnimations: parseAnimationFlag(
    process.env.REACT_APP_ENABLE_DISPLAY_ANIMATIONS
  ),
  enableAnimationLab: parseAnimationFlag(
    process.env.REACT_APP_ENABLE_ANIMATION_LAB
  ),
};

export function areDisplayAnimationsEnabled() {
  return displayAnimationFlags.enableDisplayAnimations;
}

export function isDisplayAnimationLabEnabled() {
  return displayAnimationFlags.enableAnimationLab;
}

